<template>
  <div class="studentLearning edit-style">
    <!-- :class="{ 'is-student': $route.query.isStudent }" -->
    <!--{{ searchData }}-->
    <!-- v-if="!$route.query.isStudent" -->
    <div class="navigation">
      <van-icon name="arrow-left" size="24" @click="downView" />
      <p v-if="!$route.query.isStudent" class="title">学生考点</p>
      <p v-else class="title">考点分析</p>
      <img src="@/assets/learning/setting.png" alt="" @click="toSetting" />
    </div>
    <div class="header-box">
      <div class="sort-box">
        <div
          v-for="v in sortList"
          :key="v.val"
          class="sort-list"
          :class="{ on: v.click }"
          @click="sortClick(v)"
        >
          {{ v.name }}
        </div>
      </div>
    </div>
    <knowledge
      v-if="sortList.filter((item) => item.click)[0].val == 1 && keyType"
      :search-data="searchData"
    ></knowledge>
    <overview
      v-if="sortList.filter((item) => item.click)[0].val == 2 && keyType"
      :search-data="searchData"
    ></overview>
    <wrongQuestion
      v-if="sortList.filter((item) => item.click)[0].val == 3 && keyType"
      :search-data="searchData"
    ></wrongQuestion>
  </div>
</template>

<script>
import knowledge from "@/components/learning/knowledge";
import overview from "@/components/learning/overview";
import wrongQuestion from "@/components/learning/wrongQuestion";
// import { subjectOptions } from "@/util/constdata";
import { getGradelist, classlistbygrade, querypage } from "@/api/interface";
export default {
  name: "StudentLearning",
  components: {
    knowledge,
    overview,
    wrongQuestion,
  },
  data() {
    return {
      // subjectOptions: subjectOptions,
      sortList: [
        { name: "知识点", val: 1, click: true },
        { name: "概况", val: 2, click: false },
        { name: "错题", val: 3, click: false },
      ],
      searchData: {
        subjectId: 1,
        timeRange: 0,
        gradeId: 0,
      },
      keyType: false,
      knowledList: [],
      current: 0,
      apiData: {},
    };
  },
  created() {
    this.getPhoneType();
  },
  mounted() {
    let type = this.$route.query.isWeb;
    if (type) {
      if (this.$route.query.token) {
        this.$store.commit("setToken", this.$route.query.token);
        this.$store.commit("setSchoolId", this.$route.query.schoolID);
      }
      this.apiData.gradeId = this.$route.query.gradeId;
      this.apiData.classNum = this.$route.query.classNum;
      this.apiData.studentId = this.$route.query.studentId;
      // this.apiData.subjectId = this.$route.query.subjectId;
      this.init();
    } else {
      window.initView = this.initView;
      window.goBackView = this.goBackView;
      this.initMobile();
    }
  },
  methods: {
    getPhoneType() {
      let u = navigator.userAgent;
      // this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    },
    downWindow() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 3,
        });
      } else {
        window.mobile.hideTitleBar();
      }
    },
    goBackView() {
      this.downView();
    },
    initMobile() {
      if (this.isiOS) {
        // 判断是不是学生端

        window.webkit.messageHandlers.commonCall.postMessage({
          type: 2,
        });
      } else {
        // if (this.$route.query.isStudent) {
        window.mobile.initMobile();
        // } else {
        //   window.mobile.initMobile();
        // }
      }
    },
    initView(data) {
      this.apiData = data;
      this.$store.commit("setToken", this.apiData.token);
      this.$store.commit("setSchoolId", this.apiData.schoolID);
      this.apiData.studentId = data.studentID;
      if (this.apiData.gradeID) {
        this.apiData.gradeId = this.apiData.gradeID;
      }
      Object.assign(this.searchData, this.apiData);
      // if (this.$route.query.studentId) {
      //   delete this.searchData.subjectId;
      // }
      this.init();
      // if (!this.$route.query.isStudent) {
      this.downWindow();
      // }
    },
    downView() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 1,
        });
      } else {
        window.mobile.closeMobileUI();
      }
    },
    init() {
      this.sortList[0].click = true;
      Object.assign(this.searchData, this.apiData);
      if (this.$route.query.gradeId) {
        Object.assign(this.searchData, this.$route.query);
      }

      // if (this.$route.query.isStudent) {
      //   delete this.searchData.subjectId;
      // }
      // delete this.searchData.subjectId;
      if (this.searchData.gradeId) {
        this.getClassList();
      } else {
        this.getOption();
      }
    },
    toSetting() {
      let data = JSON.parse(JSON.stringify(this.searchData));
      data.path = this.$route.name;
      data.urlType = "student";
      if (this.$route.query.isStudent) {
        data.isStudent = true;
      }
      let type = this.$route.query.isWeb;
      if (type) {
        data.isWeb = true;
      }
      delete data.current;
      delete data.size;
      delete data.token;
      delete data.schoolID;
      this.$store.commit("delKeepArr");
      this.$router.push({
        name: "SettingLearning",
        query: data,
      });
    },
    setType() {
      this.keyType = true;
    },
    getOption() {
      // let data = {
      //   token: this.apiData.token,
      //   schoolID: this.apiData.schoolID
      // };
      getGradelist().then((res) => {
        this.searchData.gradeId = res.data[0].id;
        this.getClassList();
      });
    },
    getStudent() {
      if (this.searchData.studentId) {
        this.setType();
        return;
      }
      let data = {
        classNum: this.searchData.classNum,
        current: 1,
        gradeId: this.searchData.gradeId,
        size: 100,
      };
      querypage(data).then((res) => {
        // console.log(res);
        this.searchData.studentId = res.data.records[0].id;
        this.setType();
      });
    },
    getClassList() {
      if (this.searchData.classNum) {
        this.getStudent();
        return;
      }
      let data = {
        gradeId: this.searchData.gradeId,
      };
      classlistbygrade(data).then((res) => {
        this.searchData.classNum = res.data[0].classNum;
        this.getStudent();
      });
    },
    sortClick(v) {
      this.sortList.forEach((i) => {
        i.click = false;
      });
      v.click = true;
    },
  },
};
</script>

<style scoped lang="scss">
.studentLearning {
}
</style>
